(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pv-before-after"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCompare(el) {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      var range = el.querySelector('[data-range]');
      var before = el.querySelector('[data-before]');
      var line = el.querySelector('[data-line]');
      var dragging = false;
      function set(v) {
        v = Math.max(0, Math.min(100, v));
        range.value = v;
        before.style.clipPath = 'inset(0 ' + (100 - v) + '% 0 0)';
        line.style.left = v + '%';
      }
      function fromEvent(e) {
        var r = el.getBoundingClientRect();
        set(((e.clientX - r.left) / r.width) * 100);
      }
      el.addEventListener('pointerdown', function (e) {
        dragging = true;
        // A finger landing on the photo may be starting a page scroll, so only jump on mouse click;
        // touch moves the divider once the browser confirms a sideways drag (vertical ones cancel).
        if (e.pointerType === 'mouse') fromEvent(e);
      });
      el.addEventListener('pointermove', function (e) { if (dragging) fromEvent(e); });
      ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (t) {
        el.addEventListener(t, function () { dragging = false; });
      });
      range.addEventListener('input', function () { set(Number(range.value)); });
      set(50);
    }
    function initAll() { document.querySelectorAll('[data-compare]').forEach(initCompare); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pv-combo-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var track = root.querySelector('[data-slides]');
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
      function mark(i) { thumbs.forEach(function (t, j) { t.classList.toggle('is-on', j === i); }); }
      function nearest() {
        var c = track.scrollLeft + track.clientWidth / 2, best = 0, d = Infinity;
        slides.forEach(function (s, j) { var m = Math.abs(s.offsetLeft + s.clientWidth / 2 - c); if (m < d) { d = m; best = j; } });
        return best;
      }
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var s = slides[+t.dataset.thumb];
          if (s) track.scrollTo({ left: s.offsetLeft - (track.clientWidth - s.clientWidth) / 2, behavior: 'smooth' });
          mark(+t.dataset.thumb);
        });
      });
      if (track) {
        var tm;
        track.addEventListener('scroll', function () { clearTimeout(tm); tm = setTimeout(function () { mark(nearest()); }, 80); }, { passive: true });
      }
      var bar = root.querySelector('[data-bar]');
      var area = root.querySelector('[data-buy-area]');
      if (bar && area && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          var e = es[0];
          var on = !e.isIntersecting && e.boundingClientRect.top < 0;
          bar.classList.toggle('is-on', on);
          bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        }).observe(area);
      }
    }
    function all() { document.querySelectorAll('.pvcb').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
    document.addEventListener('shopify:section:load', all);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pv-coverflow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCoverflow(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-card]'));
      var n = cards.length;
      if (!n) return;
      var active = 0, timer = null, startX = null;
      function layout() {
        var wide = window.innerWidth >= 750;
        var step = wide ? 190 : window.innerWidth * 0.36;
        cards.forEach(function (card, i) {
          var off = i - active;
          if (off > n / 2) off -= n;
          if (off < -n / 2) off += n;
          var abs = Math.abs(off);
          var scale = 1 - Math.min(abs, 3) * 0.13;
          card.style.transform = 'translateX(' + off * step + 'px) rotateY(' + (off * -18) + 'deg) scale(' + scale + ')';
          card.style.zIndex = String(20 - abs);
          card.style.opacity = abs > 2 ? '0' : '1';
          card.style.filter = abs ? 'brightness(.82)' : 'none';
          card.setAttribute('aria-hidden', abs ? 'true' : 'false');
        });
      }
      function go(d) { active = (active + d + n) % n; layout(); }
      function restart() {
        if (timer) clearInterval(timer);
        if (root.dataset.autoplay === 'true') timer = setInterval(function () { go(1); }, 3500);
      }
      root.querySelector('[data-prev]').addEventListener('click', function () { go(-1); restart(); });
      root.querySelector('[data-next]').addEventListener('click', function () { go(1); restart(); });
      cards.forEach(function (card, i) {
        card.addEventListener('click', function () { if (i !== active) { active = i; layout(); restart(); } });
      });
      var stage = root.querySelector('[data-stage]');
      stage.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) { go(dx < 0 ? 1 : -1); restart(); }
        startX = null;
      });
      window.addEventListener('resize', layout);
      layout();
      restart();
    }
    function initAll() { document.querySelectorAll('.pvcf').forEach(initCoverflow); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pv-home-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-card]'));
      var n = cards.length;
      if (!n) return;
      var dots = root.querySelector('[data-dots]');
      if (dots) cards.forEach(function () { dots.appendChild(document.createElement('span')); });
      var active = 0, timer = null, startX = null;
      function layout() {
        var wide = window.innerWidth >= 750;
        var step = wide ? 190 : window.innerWidth * 0.34;
        cards.forEach(function (card, i) {
          var off = i - active;
          if (off > n / 2) off -= n;
          if (off < -n / 2) off += n;
          var abs = Math.abs(off);
          card.style.transform = 'translateX(' + off * step + 'px) rotateY(' + (off * -18) + 'deg) scale(' + (1 - Math.min(abs, 3) * 0.13) + ')';
          card.style.zIndex = String(20 - abs);
          card.style.opacity = abs > 2 ? '0' : '1';
          card.style.filter = abs ? 'brightness(.82)' : 'none';
          card.setAttribute('aria-hidden', abs ? 'true' : 'false');
        });
        if (dots) Array.prototype.forEach.call(dots.children, function (d, i) { d.classList.toggle('is-on', i === active); });
      }
      function go(d) { active = (active + d + n) % n; layout(); }
      function restart() {
        if (timer) clearInterval(timer);
        if (root.dataset.autoplay === 'true') timer = setInterval(function () { go(1); }, 3500);
      }
      root.querySelector('[data-prev]').addEventListener('click', function () { go(-1); restart(); });
      root.querySelector('[data-next]').addEventListener('click', function () { go(1); restart(); });
      cards.forEach(function (card, i) {
        card.addEventListener('click', function () {
          if (i === active) { if (card.dataset.link) window.location.href = card.dataset.link; return; }
          active = i; layout(); restart();
        });
      });
      var stage = root.querySelector('[data-stage]');
      stage.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) { go(dx < 0 ? 1 : -1); restart(); }
        startX = null;
      });
      window.addEventListener('resize', layout);
      layout();
      restart();
    }
    function all() { document.querySelectorAll('.pvhh').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
    document.addEventListener('shopify:section:load', all);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pv-pack-picker"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initPackPicker(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var all = Array.prototype.slice.call(root.querySelectorAll('[data-card]'));
      var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-tile]'));
      var heads = Array.prototype.slice.call(root.querySelectorAll('[data-head]'));
      var ctas = Array.prototype.slice.call(root.querySelectorAll('[data-buy-cta]'));
      var line = root.querySelector('[data-pack-line]');
      var dots = root.querySelector('[data-dots]');
      var cards = [], active = 0, timer = null, startX = null;
      function layout() {
        var n = cards.length;
        if (!n) return;
        var wide = window.innerWidth >= 750;
        var step = wide ? 200 : window.innerWidth * 0.36;
        cards.forEach(function (card, i) {
          var off = i - active;
          if (off > n / 2) off -= n;
          if (off < -n / 2) off += n;
          var abs = Math.abs(off);
          var scale = 1 - Math.min(abs, 3) * 0.13;
          card.style.transform = 'translateX(' + off * step + 'px) rotateY(' + (off * -18) + 'deg) scale(' + scale + ')';
          card.style.zIndex = String(20 - abs);
          card.style.opacity = abs > 2 ? '0' : '1';
          card.style.filter = abs ? 'brightness(.82)' : 'none';
          card.setAttribute('aria-hidden', abs ? 'true' : 'false');
        });
        if (dots) {
          Array.prototype.forEach.call(dots.children, function (d, i) { d.classList.toggle('is-on', i === active); });
        }
      }
      function select(pack) {
        cards = all.filter(function (c) { return (' ' + c.dataset.packs + ' ').indexOf(' ' + pack + ' ') > -1; });
        if (!cards.length) cards = all.slice();
        all.forEach(function (c) { if (cards.indexOf(c) > -1) c.removeAttribute('data-off'); else c.setAttribute('data-off', ''); });
        if (dots) {
          dots.innerHTML = '';
          cards.forEach(function () { dots.appendChild(document.createElement('span')); });
        }
        var tile = null;
        tiles.forEach(function (t) {
          var on = t.dataset.tile === pack;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-checked', on ? 'true' : 'false');
          if (on) tile = t;
        });
        if (tile) {
          ctas.forEach(function (a) { a.href = tile.dataset.href; a.textContent = tile.dataset.cta; });
          if (line) line.textContent = tile.dataset.line || '';
        }
        heads.forEach(function (h) { h.hidden = h.dataset.head !== pack; });
        active = 0;
        layout();
        restart();
      }
      function go(d) { var n = cards.length; if (!n) return; active = (active + d + n) % n; layout(); }
      function restart() {
        if (timer) clearInterval(timer);
        if (root.dataset.autoplay === 'true') timer = setInterval(function () { go(1); }, 3500);
      }
      root.querySelector('[data-prev]').addEventListener('click', function () { go(-1); restart(); });
      root.querySelector('[data-next]').addEventListener('click', function () { go(1); restart(); });
      all.forEach(function (card) {
        card.addEventListener('click', function () {
          var i = cards.indexOf(card);
          if (i < 0) return;
          active = i === active ? (active + 1) % cards.length : i;
          layout(); restart();
        });
      });
      tiles.forEach(function (t) { t.addEventListener('click', function () { select(t.dataset.tile); }); });
      var stage = root.querySelector('[data-stage]');
      stage.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) { go(dx < 0 ? 1 : -1); restart(); }
        startX = null;
      });
      window.addEventListener('resize', layout);

      var sticky = root.querySelector('[data-sticky]');
      var mainCta = root.querySelector('.pvpp__content [data-buy-cta]');
      if (sticky && mainCta && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var e = entries[0];
          var show = !e.isIntersecting && e.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        }).observe(mainCta);
      }

      select(root.dataset.default || 'combo');
    }
    function initAll() { document.querySelectorAll('.pvpp').forEach(initPackPicker); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pv-pack-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var track = root.querySelector('[data-slides]');
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
      function nearest() {
        var c = track.scrollLeft + track.clientWidth / 2, best = 0, d = Infinity;
        slides.forEach(function (s, j) { var m = Math.abs(s.offsetLeft + s.clientWidth / 2 - c); if (m < d) { d = m; best = j; } });
        return best;
      }
      function mark(i) { thumbs.forEach(function (t, j) { t.classList.toggle('is-on', j === i); }); }
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var i = +t.dataset.thumb;
          var s = slides[i];
          if (s) track.scrollTo({ left: s.offsetLeft - (track.clientWidth - s.clientWidth) / 2, behavior: 'smooth' });
          mark(i);
        });
      });
      if (track) {
        var tm;
        track.addEventListener('scroll', function () {
          clearTimeout(tm);
          tm = setTimeout(function () { mark(nearest()); }, 80);
        }, { passive: true });
      }
      var cf = root.querySelector('[data-cf]');
      if (cf) {
        var cards = Array.prototype.slice.call(cf.querySelectorAll('[data-cf-card]'));
        var n = cards.length, act = 0, timer = null, sx = null;
        var dots = cf.querySelector('[data-cf-dots]');
        cards.forEach(function () { dots.appendChild(document.createElement('span')); });
        var lay = function () {
          var step = window.innerWidth >= 900 ? 190 : window.innerWidth * 0.33;
          cards.forEach(function (c, i) {
            var off = i - act;
            if (off > n / 2) off -= n;
            if (off < -n / 2) off += n;
            var a = Math.abs(off);
            c.style.transform = 'translateX(' + off * step + 'px) rotateY(' + (off * -18) + 'deg) scale(' + (1 - Math.min(a, 3) * 0.13) + ')';
            c.style.zIndex = String(20 - a);
            c.style.opacity = a > 2 ? '0' : '1';
            c.style.filter = a ? 'brightness(.82)' : 'none';
          });
          Array.prototype.forEach.call(dots.children, function (d, i) { d.classList.toggle('is-on', i === act); });
        };
        var go = function (d) { act = (act + d + n) % n; lay(); };
        var again = function () { clearInterval(timer); timer = setInterval(function () { go(1); }, 3200); };
        cards.forEach(function (c, i) { c.addEventListener('click', function () { act = i; lay(); again(); }); });
        var st = cf.querySelector('[data-cf-stage]');
        st.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
        st.addEventListener('touchend', function (e) {
          if (sx === null) return;
          var dx = e.changedTouches[0].clientX - sx;
          if (Math.abs(dx) > 40) { go(dx < 0 ? 1 : -1); again(); }
          sx = null;
        });
        window.addEventListener('resize', lay);
        if (n) { lay(); again(); }
      }
      var bar = root.querySelector('[data-bar]');
      var area = root.querySelector('[data-buy-area]');
      if (bar && area && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          var e = es[0];
          var on = !e.isIntersecting && e.boundingClientRect.top < 0;
          bar.classList.toggle('is-on', on);
          bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        }).observe(area);
      }
    }
    function all() { document.querySelectorAll('.pvpk').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
    document.addEventListener('shopify:section:load', all);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pv-pack-strip"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var vp = root.querySelector('[data-viewport]');
      var cards = vp ? vp.querySelectorAll('.pvst__card') : [];
      if (!vp || cards.length < 2) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var wait = Math.max(1500, (parseFloat(root.dataset.speed) || 20) * 150);
      var paused = false, resume = null;
      function step() {
        if (paused || vp.scrollWidth <= vp.clientWidth + 4) return;
        var cardW = cards[0].getBoundingClientRect().width + 12;
        var atEnd = vp.scrollLeft + vp.clientWidth >= vp.scrollWidth - 4;
        vp.scrollTo({ left: atEnd ? 0 : vp.scrollLeft + cardW, behavior: 'smooth' });
      }
      function hold() { paused = true; clearTimeout(resume); resume = setTimeout(function () { paused = false; }, 4000); }
      ['touchstart', 'pointerdown', 'wheel', 'mouseenter'].forEach(function (t) { vp.addEventListener(t, hold, { passive: true }); });
      setInterval(step, wait);
    }
    function all() { document.querySelectorAll('[data-pvst]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
    document.addEventListener('shopify:section:load', all);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pv-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initReviews(root) {
      if (root.dataset.ready) return;
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-card]'));
      if (!cards.length) return;
      root.dataset.ready = '1';
      var dots = root.querySelectorAll('.pvts__dot');
      var stage = root.querySelector('[data-stage]');
      var n = cards.length, active = 0, startX = null;
      function layout() {
        var maxH = 0;
        cards.forEach(function (card, i) {
          var off = i - active;
          if (off > n / 2) off -= n;
          if (off < -n / 2) off += n;
          var abs = Math.abs(off);
          card.style.transform = 'translateX(' + off * 92 + '%) scale(' + (abs ? 0.9 : 1) + ')';
          card.style.opacity = abs > 1 ? '0' : abs ? '0.55' : '1';
          card.style.zIndex = String(10 - abs);
          maxH = Math.max(maxH, card.offsetHeight);
        });
        stage.style.height = maxH + 24 + 'px';
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === active); });
      }
      function go(d) { active = (active + d + n) % n; layout(); }
      root.querySelector('[data-prev]').addEventListener('click', function () { go(-1); });
      root.querySelector('[data-next]').addEventListener('click', function () { go(1); });
      stage.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
        startX = null;
      });
      window.addEventListener('resize', layout);
      layout();
    }
    function initAll() { document.querySelectorAll('.pvts').forEach(initReviews); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
